"use client";
import React, { FC, useEffect, useState } from "react";
import Image from "next/image";

interface InvestmentCarouselItem {
    title: string;
    image: string;
    description?: string;
}

const InvestmentCarouselData: InvestmentCarouselItem[] = [
    // {
    //     title: "One platform for all your alternate investments",
    //     image: "https://assets.incredmoney.com/images/webp/icmLoginGenricImage1.webp",
    // },
    // {
    //     title: "Invest in the best Unlisted Shares",
    //     description: "Get started with just 1 share",
    //     image: "https://assets.incredmoney.com/images/webp/icmLoginGenricImage3.webp",
    // },
    // {
    //     title: "Confirm your purchase today & get rewarded",
    //     image: "https://assets.incredmoney.com/images/webp/ReferMobile.webp",
    // },
    {
        title: "Trade smarter with unlimited trades at ₹999/month",
        image: "https://assets.incredmoney.com/images/webp/icmLoginGenricImage5.webp",
    },
    {
        title: "Invest in digital gold and silver starting at just ₹10",
        image: "https://assets.incredmoney.com/images/webp/icmLoginGenricImage4.webp",
    },
];

interface InvestmentCarouselProps {
    autoPlay?: boolean;
    slideInterval?: number;
}

const SLIDE_TIMEOUT = 4000;

const MobileImageCarousel: FC<InvestmentCarouselProps> = ({
    autoPlay = false,
    slideInterval = SLIDE_TIMEOUT,
}) => {
    const [activeSlide, setActiveSlide] = useState(0);
    const [touchStartX, setTouchStartX] = useState<number | null>(null);
    const [touchEndX, setTouchEndX] = useState<number | null>(null);

    useEffect(() => {
        if (!autoPlay) return;

        const interval = setInterval(() => {
            setActiveSlide((prev) => (prev + 1) % InvestmentCarouselData.length);
        }, slideInterval);

        return () => clearInterval(interval);
    }, [autoPlay, slideInterval]);

    const handleTouchStart = (e: React.TouchEvent) => {
        setTouchStartX(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        setTouchEndX(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStartX || !touchEndX) return;

        const swipeDistance = touchStartX - touchEndX;

        // Sensitivity threshold
        if (swipeDistance > 50) {
            // swipe left → next slide
            setActiveSlide((prev) => (prev + 1) % InvestmentCarouselData.length);
        }

        if (swipeDistance < -50) {
            // swipe right → prev slide
            setActiveSlide((prev) =>
                prev === 0 ? InvestmentCarouselData.length - 1 : prev - 1
            );
        }

        // Reset
        setTouchStartX(null);
        setTouchEndX(null);
    };

    return (
        <div
            className="relative w-full overflow-hidden md:hidden"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            {/* Slider wrapper */}
            <div
                className="flex transition-transform duration-700 ease-in-out"
                style={{ transform: `translateX(-${activeSlide * 100}%)` }}
            >
                {InvestmentCarouselData.map((item, index) => (
                    <div
                        key={index}
                        className="flex min-h-full w-full flex-shrink-0 flex-col"
                    >
                        {/* Heading */}
                        <div className="mb-1 text-left">
                            <h2 className="text-center text-lg font-semibold leading-tight text-gray-800">
                                {item.title}
                            </h2>
                            {item?.description && (
                                <p className="mt-4 text-center text-sm font-medium leading-snug text-gray-600">
                                    {item?.description}
                                </p>
                            )}
                        </div>

                        {/* Card */}
                        <div className="w-full rounded-xl bg-white">
                            <Image
                                src={item.image}
                                alt={item.title}
                                width={400}
                                height={300}
                                className="w-[90%] h-auto rounded-lg object-contain m-auto"
                            />
                        </div>
                    </div>
                ))}
            </div>

            {/* Dots Navigation */}
            <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 transform gap-1">
                {InvestmentCarouselData.map((_, slideIndex) => (
                    <button
                        key={slideIndex}
                        className={`h-2 w-2 rounded-full transition-all duration-300 ${
                            slideIndex === activeSlide
                                ? "scale-125 bg-orange-500"
                                : "bg-gray-300"
                        }`}
                        onClick={() => setActiveSlide(slideIndex)}
                        aria-label={`Go to slide ${slideIndex + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default MobileImageCarousel;
